import { useEffect, useMemo, useState } from 'react';
import useIdentityContext from './useIdentityContext';
import { getProfile } from '../apis/profileApi';
import type { IShopperProfile } from '../types/ShopperProfile.types';

// TODO: Might be worth refactoring this to better support rendering use cases:
// Are we waiting for a response from the profile service?
// Has the profile service failed?
// et cetera
const useShopperProfile = (): IShopperProfile | null => {
  const { identity } = useIdentityContext();
  const [profile, setProfile] = useState<IShopperProfile | null>(null);

  useEffect(() => {
    if (identity.isShopper) {
      (async () => {
        const userProfile = await getProfile();
        if (userProfile !== undefined) {
          setProfile(userProfile);
        }
      })();
    }
  }, [identity.isShopper]);

  return useMemo(() => profile, [profile]);
};

export default useShopperProfile;
